import { render, staticRenderFns } from "./RoomLog.vue?vue&type=template&id=06b1d0ae&"
import script from "./RoomLog.vue?vue&type=script&lang=js&"
export * from "./RoomLog.vue?vue&type=script&lang=js&"
import style0 from "./RoomLog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports